module.exports = __webpack_public_path__ + "static/assets/8b65c3c5c1daea486434d91f9e5dba42.png";